<template>
    <div class="downLayout">
        <div class="downLayout-dataView">
            <div class="downLayout-imageLayout">
                <img :src="appLogo">
            </div>
            <div class="downLayout-swipeLayout">
                <van-swipe :autoplay="3000" :duration='100' indicator-color='#39A9ED'>
                    <van-swipe-item v-for="img in SwipeImage" :key="img">
                        <img :src="img" >
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="downLayout-btnsLayout">
                <div class="downLayout-btnsLayout-cell">
                    <img :src="androidBtnImg" @click="downAppForAndroid()" >
                </div>
                <div class="downLayout-btnsLayout-cell">
                    <img :src="iosBtnImg"   @click="downAppForIOS()">
                </div>
            </div>
        </div>
        <div v-if="showGuideImg" class="is-weichat" @click="hideGuideImage"><img :src="guideImg"></div>
    </div>
</template>
<script>
import {isWeiXin} from '../../common/functionUtil';

import mstxLogo from '@/assets/crmapp/LOGO白背景.png';
import app1 from '@/assets/crmapp/用户页面.png';
import app3 from '@/assets/crmapp/首页界面.png';
import app2 from '@/assets/crmapp/创客页面.png';
import androidBtnImg from '@/assets/crmapp/安卓.png';
import iosBtnImg from '@/assets/crmapp/苹果.png';
import backImg from '@/assets/crmapp/下载.png';


import guide from '@/assets/crmapp/guide.jpg';


export default {
    data(){
        return{
            backImg:backImg,
            appLogo:mstxLogo,
            guideImg:guide,
            androidBtnImg:androidBtnImg,
            iosBtnImg:iosBtnImg,
            textDesc:'民生通讯',
            showGuideImg:false,
            SwipeImage:[
                app1,
                app2,
                app3
            ]
        }
    },
    created(){

    },
    methods:{
        isWeiXin,
        downAppForAndroid(){
            if(this.isWeiXin()){
                this.showGuideImg = true;
            }else{
                location.href='http://www.ms170.cn/民生通讯.apk';
            }
        },
        hideGuideImage(){
            this.showGuideImg = false;
        }
        ,
      downAppForIOS(){
        if(this.isWeiXin()){
          this.showGuideImg = true;
        }else{
          location.href='https://apps.apple.com/cn/app/小民快赚/id6444306771';
        }
      },

    },

}
</script>
<style>
html,body,#app,.home{
    height: 100% !important;
}
</style>
<style lang="less" scoped>
.is-weichat{position: fixed;top: 0;left: 0;width: 100%;height: 100%;background-color: #898886;}
.is-weichat>img{width: 100%;display: block;}
.downLayout{
    height: 100% !important;
    width: 100% !important;
    text-align: center;
    vertical-align: middle;
    background-image: url("../../assets/crmapp/下载.png");
    background-size: 100% 100%;
         position: relative;
    &-dataView{
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    &-imageLayout{
        margin: 0 auto;
        img{
            width: 45%;
        }
    }
    &-swipeLayout{
        width: 55% !important;
        margin: 0 auto;
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
        img {
            width: 100%;
            display: block;
        }
    }
    &-btnsLayout{
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 20px;
        &-cell{
            margin-top: 10px;
            img{
                width: 70%;
            }
        }
    }
}

</style>